// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2020project/2020composition/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};
interface IList {
  schoolType?: string;
  search?: string;
}
const getList = (p: IList) => {
  const { schoolType, search } = p;
  return http.get(`${urlPrefix}vote-list-prize`, {
    params: {
      schoolType,
      page: 1,
      search,
    },
  });
};

export { getBaseInfo, getRule, getList };
